import { defineMessage } from "@formatjs/intl";

export const MESSAGES = defineMessage({
	balance: {
		id: "balance",
		defaultMessage: "Balance: {balance} USDC",
	},
});
